import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [
	{ title: 'Business Continuity Planning' },
	{
		name: 'description',
		content:
			'Plan ahead by researching the threats that could disrupt the operation of your business and handle each threat accordingly.',
	},
]

export default function Component() {
	return (
		<>
			<h1 className="py-3 text-4xl font-black">Business Continuity Planning</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Plan ahead by researching the threats that could disrupt the operation
				of your business and handle each threat accordingly.
			</p>
		</>
	)
}
